export default __webpack_public_path__ + "static/media/utilizationRate.e97b49d0.svg";